<template>
  <div class="legacy-data-table-loader" role="progressbar" aria-label="Loading">
    <div class="legacy-data-table-loader__bar"></div>
  </div>
</template>
